import React, { useEffect } from 'react';
import { acknowledgeLiveUpdateReady } from '../lib/liveUpdates';

export function PageReady({ children = null }) {
  useEffect(() => {
    // A suspended or failed page never commits this effect. Allow redirects and
    // the first paint to complete before acknowledging the downloaded bundle.
    const frame = requestAnimationFrame(() => {
      void acknowledgeLiveUpdateReady();
    });
    return () => cancelAnimationFrame(frame);
  }, []);
  return children;
}

/** Same lazy-loading contract as React.lazy, with a route health acknowledgement. */
export default function lazyPage(load) {
  return React.lazy(async () => {
    const module = await load();
    const Page = module.default;
    return {
      ...module,
      default: function ReadyPage(props) {
        return <PageReady><Page {...props} /></PageReady>;
      },
    };
  });
}
